export const defaultSelected = 'selected'
export const defaultPagination = 'pagination'
export const defaultSort = 'sort'
export const defaultFilter = 'filter'
export const defaultPreFilter = 'prefilter'
export const preserveRecursive = 'preserveRecursive'
export const defaultRadioSelect = 'radioSelect'
export const defaultDatetime = 'datetime'
export const defaultTime = 'time'
export const defaultTab = 'tab'